import { render } from "./DatosAccionante.vue?vue&type=template&id=bf6dbe44"
import script from "./DatosAccionante.vue?vue&type=script&lang=js"
export * from "./DatosAccionante.vue?vue&type=script&lang=js"

import "./DatosAccionante.vue?vue&type=style&index=0&id=bf6dbe44&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__